import Vue from "vue";
import VueRouter from "vue-router";
import routes from "@/router/routes";
import store from "@/store";
import i18n from '@/i18n'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: "history",

  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  // Hide side menu
  store.commit("app/hideMainMenu");

  // set Top Menu
  store.commit("app/setTopMenu", routeTo.meta.topMenu);

  // Check if auth is required on this route including nested routes.
  const authRequired = routeTo.matched.some(route => route.meta.auth);
  const isLoggedIn = store.getters["user/loggedIn"];
  if (routeTo.name == "onBoarding") {
    if (Vue.$cookies.get("newUser") == null) {
      Vue.$cookies.set("newUser", false, '30d');
    } else {
      next({
        name: "offerSearch"
      })
    }
  }
  if (routeTo.name == "onBoarding") {
    Vue.$cookies.set("newUser", false, '30d');
  }

  // if (routeTo.name == "confirmCell") {
  //   if (Vue.$cookies.get("newUser") == true) {
  //     next({
  //       name: "onBoarding",
  //     });
  //   }
  //   else if (Vue.$cookies.get("newUser") == null) {
  //     next({
  //       name: "onBoarding",
  //     });
  //   }
  //   else {
  //     // router.push({
  //     //   name: "confirmCell",
  //     // })
  //     next();
  //   }
  // }
  // If auth isn't required for the route, just continue.
  if (!authRequired) {
    if (isLoggedIn) {
      if (
        ["checkLastName", "confirmCell", "confirmOtp"].includes(routeTo.name)
      ) {

        next({ name: "offerSearch" });
      } else {
        if (routeTo.name === "checkLastname") {
          if (store.getters["user/invitationVerified"]) {
            next();
          } else {

            next({
              name: "confirmCell",
              query: { redirect: routeTo.fullPath }
            });
          }
        } else next();
      }
    } else {

      if (routeTo.name == "confirmCell") {
        if (Vue.$cookies.get("newUser") === 'false') {
          next();
        } else {
          next({
            name: "onBoarding",
            query: [true]
          });
        }
      } else if (routeTo.name === "checkLastname") {
        if (Vue.$cookies.get("newUser") === 'false') {
          if (store.getters["user/invitationVerified"]) {
            next();
          } else {
            next({ name: "confirmCell" });
          }
        } else {
          next({
            name: "onBoarding",
            query: [true]
          });
        }
      }
      else {
        next();
      }
      // if (routeTo.name === "checkLastname") {
      //   if (store.getters["user/invitationVerified"]) {
      //     next();
      //   } else {
      //     next({ name: "confirmCell" });
      //   }
      // } else next();
    }
  } else {
    // If auth is required and the user is logged in...
    if (isLoggedIn) {
      // Validate the local user token...
      store.dispatch("user/validate").then(validUser => {
        // Then continue if the token still represents a valid user,
        // otherwise redirect to login.
        validUser
          ? next()
          : next({
            name: "confirmCell",
            query: { redirect: routeTo.fullPath }
          });
      });
    } else if (routeTo.name === "Applications") {
      store.commit("app/showNotification", {
        desc:
          i18n.t("pages.common.buttons.dis82"),
        buttons: {
          okay: {
            text: i18n.t("pages.common.buttons.dis85"),
            action: () => { }
          }
        }
      });
    } else if (routeTo.name === "favoriteOffers") {

      store.commit("app/showNotification", {
        heading: i18n.t("pages.common.buttons.dis83"),
        desc:
          i18n.t("pages.common.buttons.dis84"),
        buttons: {
          okay: {
            text: i18n.t("pages.common.buttons.dis85"),
            action: () => { }
          }
        }
      });
    } else if (routeTo.name === "ProfileLanding") {
      store.commit("app/showNotification", {
        heading: i18n.t("pages.common.buttons.dis173"),
        desc:
          i18n.t("pages.common.buttons.dis174"),
        buttons: {
          okay: {
            text: i18n.t("pages.common.buttons.dis85"),
            action: () => {

             }
          }
        }
      });
    } else {
      if (store.getters["user/auth"].newUser) {
        next({ name: "acceptContract" });
      } else {
        next({
          name: "confirmCell",
          query: { redirect: routeTo.fullPath }
        });
      }
    }
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

export default router;
